import { render, staticRenderFns } from "./horizontal-scroll-type-checker.vue?vue&type=template&id=4051c291&scoped=true&"
import script from "./horizontal-scroll-type-checker.vue?vue&type=script&lang=ts&"
export * from "./horizontal-scroll-type-checker.vue?vue&type=script&lang=ts&"
import style0 from "./horizontal-scroll-type-checker.vue?vue&type=style&index=0&id=4051c291&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051c291",
  null
  
)

export default component.exports